import { FormBuilderType, FormBuilderValidator } from "@grassrootly/rn-core";

export interface IJoinGroupForm {
  join_code: string;
}

export const joinForm: FormBuilderType<IJoinGroupForm> = {
  join_code: {
    type: "input",
    name: "join_code",
    label: "",
    defaultValue: "",
    validators: [FormBuilderValidator.required(), FormBuilderValidator.minChar(3)],
    required: true,
    props: {
      keyboardType: "name-phone-pad",
      placeholder: "Team join code",
    },
  },
};

export interface JoinGroupProps {
  loading?: boolean;
  joinGroupForm: FormBuilderType<IJoinGroupForm>;
  onSubmit: (join_code: string | { join_code: string }) => void;
}
